export default __webpack_public_path__ + "static/media/shutterstock_1894351126.10305a9c.png";